<template>
  <div :class="`vp-datepicker-container-${uniqueKey}`">
    <!-- start::Label -->
    <span
      class="vp-datepicker-label"
      :class="{ 'disabled-color': disabled }"
      v-if="value"
    >
      {{ placeholder }}
    </span>
    <!-- end::Label -->

    <!-- start::Datepicker -->
    <date-picker
      id="from_time"
      class="vp-datepicker"
      :class="{
        'selected-date-value': value,
        invalid: invalid,
        'datepicker-without-placeholder': !placeholder,
      }"
      :placeholder="placeholder"
      :value="value"
      :disabled="disabled"
      :disabledDate="disabledDate"
      :format="format"
      :first-day-of-week="1"
      :value-type="valueType"
      :type="type"
      @input="updateDatePicker"
    >
      <i slot="icon-calendar">
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="#787878"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.666656 14.8332C0.666656 16.2498 1.74999 17.3332 3.16666 17.3332H14.8333C16.25 17.3332 17.3333 16.2498 17.3333 14.8332V8.1665H0.666656V14.8332ZM14.8333 2.33317H13.1667V1.49984C13.1667 0.999837 12.8333 0.666504 12.3333 0.666504C11.8333 0.666504 11.5 0.999837 11.5 1.49984V2.33317H6.49999V1.49984C6.49999 0.999837 6.16666 0.666504 5.66666 0.666504C5.16666 0.666504 4.83332 0.999837 4.83332 1.49984V2.33317H3.16666C1.74999 2.33317 0.666656 3.4165 0.666656 4.83317V6.49984H17.3333V4.83317C17.3333 3.4165 16.25 2.33317 14.8333 2.33317Z"
          />
        </svg>
      </i>
    </date-picker>
    <!-- end::Datepicker -->

    <!-- start::Error Message -->
    <p v-if="invalid && errMsg" class="vp-datepicker-error-message">
      {{ errMsg }}
    </p>
    <!-- end::Error Message -->
  </div>
</template>

<script>
import { randomStringMixin } from "@/utils/mixins/generateRandomStringMixin";

export default {
  mixins: [randomStringMixin],
  data() {
    return {
      uniqueKey: this.randomString(10),
    };
  },
  props: {
    value: {
      default: () => null,
    },
    placeholder: {
      type: String,
      default: "",
    },
    format: {
      type: String,
      default: "DD/MM/YYYY",
    },
    valueType: {
      type: String,
      default: "format",
    },
    type: {
      type: String,
      default: "date",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledDate: {
      type: Function,
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    errMsg: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "250",
    },
  },
  methods: {
    updateDatePicker(value) {
      this.$emit("input", value);
    },
    setDatepickerWidth() {
      setTimeout(() => {
        const datepicker = document.querySelector(
          `.vp-datepicker-container-${this.uniqueKey} .mx-datepicker`
        );
        if (datepicker) {
          datepicker.style.setProperty("width", `${this.width}px`, "important");
        } else {
          console.error("Date picker not found.");
        }
        const err = document.querySelector(
          `.vp-datepicker-container-${this.uniqueKey} .vp-datepicker-error-message`
        );
        if (err) {
          err.style.setProperty("width", `${this.width}px`, "important");
        } else {
          console.error("Error message not found.");
        }
      }, 0);
    },
  },
  watch: {
    width() {
      this.setDatepickerWidth();
    },
    invalid() {
      this.setDatepickerWidth();
    },
  },
  beforeMount() {
    this.setDatepickerWidth();
  },
};
</script>

<style lang="scss">
div[class*="vp-datepicker"] {
  position: relative;
  font-weight: 700 !important;
  letter-spacing: 0.25px;

  .vp-datepicker.disabled .mx-input::placeholder {
    color: #c1c1c1;
  }

  // disabled color (without value)
  .vp-datepicker.disabled .mx-icon-calendar {
    color: #c1c1c1 !important;
  }

  // disabled color (with value)
  .vp-datepicker.selected-date-value.disabled .mx-icon-calendar {
    color: #9fb2bf !important;
  }

  // datepicker icon without date selected
  .vp-datepicker .mx-icon-calendar {
    color: #787878 !important;
  }

  // datepicker icon with date selected
  .mx-datepicker.selected-date-value .mx-icon-calendar {
    color: #103f5e !important;
  }

  .vp-datepicker.disabled .mx-input {
    color: #afafaf !important;
  }

  input.mx-input {
    padding: 12px 20px !important;
    background-color: #f2f2f2 !important;
    border: 1.5px solid transparent !important;
    line-height: 19px !important;
    color: #4a4a4a !important;
  }
  input.mx-input::placeholder {
    color: #787878;
  }

  .mx-input {
    height: 55px !important;
  }
  .selected-date-value .mx-input {
    padding-top: 31px !important;
  }
  .datepicker-without-placeholder .mx-input {
    padding-top: 10px !important;
  }
  .mx-datepicker {
    width: 416px;
  }
  .vp-datepicker i {
    inset-inline-end: 20px;
  }

  .invalid input.mx-input {
    border: 1.5px solid #f46a6a !important;
    border-radius: 4px;
  }

  span.vp-datepicker-label {
    position: absolute;
    color: var(--Main-Button, #103f5e);
    font-size: 12px;
    line-height: 14px;
    z-index: 2;
    top: 12px;
    inset-inline-start: 22px;
  }
  .vp-datepicker-error-message {
    // margin-top: 8px;
    padding-inline-start: 20px;
    padding-inline-end: 20px;
    margin-bottom: 16px;
    align-items: center;
    display: flex;
    width: fit-content !important;
    word-break: break-all;
    font-size: 14px !important;
    line-height: 22px !important;
    color: #f46a6a !important;
    margin-top: 8px;
    font-weight: 600 !important;
  }
  .disabled-color {
    color: #9fb2bf !important;
  }
}
</style>
